import { render, staticRenderFns } from "./TranslationsHead.vue?vue&type=template&id=bca6732e"
import script from "./TranslationsHead.vue?vue&type=script&lang=js"
export * from "./TranslationsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports